import { Dialog, DialogActions, DialogContent, DialogTitle, Typography, List, ListItemButton, Box, Button } from '@mui/material';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';

const SecurityDepositInvoiceListModal = ({ open, invoices, onClose }) => {
    const handleInvoiceClick = (invoiceSlug) => {
        window.open(`/invoices/view/${invoiceSlug}`, "_blank");
    };

    return (
        <Dialog open={open} onClose={onClose} aria-labelledby="security-deposit-invoice-list-dialog-title" PaperProps={{ sx: { width: '360px', borderRadius: '8px' } }}>
            <DialogTitle id="security-deposit-invoice-list-dialog-title" className='dialog-header' sx={{ padding: '12px 20px' }}>
                <Typography component="span" sx={{ fontSize: '15px', fontWeight: 600 }}>
                    Security Deposit Invoices
                </Typography>
                {invoices?.length > 0 &&
                    <Typography component="div" sx={{ fontSize: '12px', color: 'text.secondary', mt: '2px' }}>
                        {invoices.length} invoice{invoices.length > 1 ? 's' : ''} linked
                    </Typography>}
            </DialogTitle>
            <DialogContent sx={{ padding: '8px 0', maxHeight: '360px', overflowY: 'auto' }}>
                {invoices?.length > 0 ? (
                    <List sx={{ padding: 0 }}>
                        {invoices.map((invoice, index) => (
                            <ListItemButton
                                key={invoice?.invoice_slug || index}
                                onClick={() => handleInvoiceClick(invoice?.invoice_slug)}
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    padding: '10px 20px',
                                    '&:hover': { backgroundColor: '#F5F7FD' },
                                }}
                            >
                                <DescriptionOutlinedIcon sx={{ fontSize: '18px', color: '#5C6BC0' }} />
                                <Typography
                                    sx={{ fontSize: '13px', flexGrow: 1, color: 'primary.main', fontWeight: 500 }}
                                >
                                    {invoice?.invoice_number || '--'}
                                </Typography>
                                <OpenInNewIcon sx={{ fontSize: '14px', color: 'text.secondary' }} />
                            </ListItemButton>
                        ))}
                    </List>
                ) : (
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px', padding: '30px 20px' }}>
                        <InboxOutlinedIcon sx={{ fontSize: '32px', color: 'text.disabled' }} />
                        <Typography sx={{ fontSize: '13px', color: 'text.secondary' }}>No invoices available.</Typography>
                    </Box>
                )}
            </DialogContent>
            <DialogActions sx={{ padding: '10px 16px', borderTop: '1px solid #EFEFEF' }}>
                <Button onClick={onClose} size="small" variant="outlined" color="primary">Close</Button>
            </DialogActions>
        </Dialog>
    );
};

export default SecurityDepositInvoiceListModal;
